import * as api from '@/api'
import { formatTimestamp } from '@/helpers/formatTimestamp'

const GET_DATE_PERIOD = 'GET_DATE_PERIOD'
const GET_STUDENTS = 'GET_STUDENTS'
const GET_STUDENT = 'GET_STUDENT'
const GET_TRAYS = 'GET_TRAYS'

const LOADING_REQUEST = 'LOADING_REQUEST'
const ERROR_REQUEST = 'ERROR_REQUEST_STUDENTS'
const REQUEST_PRECONFIG = 'REQUEST_PRECONFIG'

const initialState = {
  datePeriod: {},
  listStudents: [],
  listTrays: [],
  student: {},
  errorRequest: null,
  loadingRequest: false
}

const state = { ...initialState }

const mutations = {
  [GET_DATE_PERIOD] (state, payload) {
    state.datePeriod = payload
  },

  [GET_STUDENT] (state, student) {
    state.student = student
  },

  [GET_STUDENTS] (state, students) {
    state.listStudents = students
  },

  [GET_TRAYS] (state, trays) {
    state.listTrays = trays
  },

  [ERROR_REQUEST] (state, error) {
    state.errorRequest = error
  },

  [LOADING_REQUEST] (state, loading) {
    state.loadingRequest = loading
  },

  [REQUEST_PRECONFIG] (state) {
    state.emptyRequest = initialState.emptyRequest
    state.errorRequest = initialState.errorRequest
    state.loadingRequest = true
  }
}

const actions = {
  getStudents ({ commit }, responsibleId) {
    commit(REQUEST_PRECONFIG)
    api.students.getStudents(responsibleId)
      .then(({ data }) => {
        const students = data
        commit(GET_STUDENTS, students)
      })
      .catch(error => {
        commit(ERROR_REQUEST, error)
      })
      .finally(() => {
        commit(LOADING_REQUEST, false)
      })
  },

  getStudentTrays ({ commit }, params) {
    commit(REQUEST_PRECONFIG)
    api.mealControl.trays.getTraysByStudent(params)
      .then(response => {
        const { trays: dataTrays, student } = response.data
        commit(GET_STUDENT, student)
        commit(GET_TRAYS, dataTrays)
      })
      .catch(error => {
        commit(ERROR_REQUEST, error)
      })
      .finally(() => {
        commit(LOADING_REQUEST, false)
      })
  },

  pushDatePeriod ({ commit }, datePeriod) {
    commit(GET_DATE_PERIOD, datePeriod)
  }
}

const getters = {
  getStudentParams (state) {
    const formatDate = 'DD/MM/YYYY'
    return {
      startDate: formatTimestamp((state.datePeriod || {}).start, formatDate),
      endDate: formatTimestamp((state.datePeriod || {}).end, formatDate)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
